import { FC } from "react";
import styles from "./HowItWorks.module.scss";
import { Container } from "~/components/Container";
import Image from "next/image";
import classNames from "classnames";
import { format } from "date-fns";

const socials = [
  {
    url: "/svgs/whatsapp.svg",
    alt: "Whatsapp",
  },
  {
    url: "/svgs/messenger.svg",
    alt: "Messenger",
  },
  {
    url: "/svgs/instagram.svg",
    alt: "Instagram",
  },
  {
    url: "/svgs/shopify.svg",
    alt: "Shopify",
  },
  {
    url: "/svgs/wordpress.svg",
    alt: "Wordpress",
  },
  {
    url: "/svgs/discord.svg",
    alt: "Discord",
  },
  {
    url: "/svgs/telegram.svg",
    alt: "Telegram",
  },
];

const HowItWorks: FC = () => {
  const messageTime = format(new Date(), "HH:mm");

  return (
    <section className={styles.how_it_works}>
      <Container>
        <div className={styles.container}>
          <div className="flex flex-col gap-2 items-center">
            <h2 className={styles.title} data-aos="fade-down">
              Create AI Agents & solve all chats in 3 steps
            </h2>
            <p className={styles.description} data-aos="fade-up">
              No rocket science practice required. Do everything like a going
              for walk.
            </p>
          </div>

          <div className={styles.steps}>
            <div className={styles.step_item}>
              <div className={styles.line_wrapper}>
                <div className={styles.line} />
                <div className={styles.dot} />
              </div>
              <div className={styles.wrapper}>
                <div className={styles.content}>
                  <div className="flex justify-between items-center">
                    <h3 className={styles.title}>Sign up for Free</h3>
                    <h4 className={styles.number}>#1</h4>
                  </div>

                  <p className={styles.description}>
                    No credit card required. Try it free & see how AI works.
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.step_item}>
              <div className={styles.line_wrapper}>
                <div className={styles.line} />
                <div className={styles.dot} />
              </div>
              <div className={styles.wrapper}>
                <div className={styles.content}>
                  <div className="flex justify-between items-center">
                    <h3 className={styles.title}>Customize your AI Agent</h3>
                    <h4 className={styles.number}>#2</h4>
                  </div>

                  <p className={styles.description}>
                    Go live in minutes with our templates or go in details with
                    our visualized Workflow.
                  </p>

                  <div className={styles.bot_wrapper}>
                    <p className={styles.name}>Bot name</p>
                    <p className={styles.description}>My CX Genie|</p>

                    <div className={styles.image}>
                      <Image
                        src="/svgs/cxgenie_head_2.svg"
                        alt="CX Genie"
                        width={24}
                        height={24}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.step_item}>
              <div className={styles.line_wrapper}>
                <div className={styles.line} />
                <div className={styles.dot} />
              </div>
              <div className={styles.wrapper}>
                <div className={styles.content}>
                  <div className="flex gap-6 justify-between items-center">
                    <h3 className={styles.title}>
                      Go live at any platforms you want
                    </h3>
                    <h4 className={styles.number}>#3</h4>
                  </div>

                  <p className={styles.description}>
                    Just click to connect your AI Agent to any platform you
                    want. Let AI start doing the work for you.
                  </p>

                  <div className="flex gap-8 md:gap-14">
                    <div className="grid grid-cols-4 gap-[14px] h-fit">
                      {socials.map((social, index) => (
                        <div className={styles.social_item} key={index}>
                          <Image
                            src={social.url}
                            alt={social.alt}
                            width={30}
                            height={30}
                            className="w-4 h-4 md:w-[30px] md:h-[30px]"
                          />
                        </div>
                      ))}
                    </div>

                    <div className={styles.chat_bot}>
                      <div className={styles.header}>
                        <div className={styles.logo}>
                          <Image
                            src="/svgs/cxgenie_head_3.svg"
                            alt="CX Genie"
                            width={8}
                            height={8}
                          />
                        </div>

                        <p className={styles.name}>Your Bot</p>
                      </div>

                      <div className={styles.body}>
                        <div
                          className={classNames(styles.message, styles.mine)}
                        >
                          <p className={styles.text}>Hello!</p>
                          <p className={styles.date}>Today, {messageTime}</p>
                        </div>

                        <div className={styles.message_wrapper}>
                          <div className={styles.logo}>
                            <Image
                              src="/svgs/cxgenie_head_3.svg"
                              alt="CX Genie"
                              width={8}
                              height={8}
                            />
                          </div>
                          <div className={styles.message}>
                            <p className={styles.text}>
                              Hello, what can I do for you?
                            </p>
                            <p className={styles.date}>Today, {messageTime}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HowItWorks;
